<template>
  <div class="search-condition-wrap">
    <div class="button-wrap">
      <el-button type="primary" style="width: 110px" @click="openDialog('searchNews')">修改條件</el-button>
    </div>
    <el-descriptions :column="2" size="large" style="width: 100%" v-if="getSearchCondition">
      <el-descriptions-item label-class-name="descriptions-label" label="活動名稱">
        {{ getSearchCondition.event_name || '未設定' }}
      </el-descriptions-item>
      <el-descriptions-item label-class-name="descriptions-label" label="活動ID">
        {{ getSearchCondition.event_id || '未設定' }}
      </el-descriptions-item>
      <el-descriptions-item label-class-name="descriptions-label" label="狀態">
        {{ getSearchCondition.available_status || '未設定' }}
      </el-descriptions-item>
      <el-descriptions-item label-class-name="descriptions-label" label="活動日期">
        {{ getDateText(getSearchCondition.date) }}
      </el-descriptions-item>
    </el-descriptions>
  </div>

  <!-- 彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { useGetters } from '@/utils/mapStore';
import { defineAsyncComponent } from 'vue';
import { useDialog } from '@/utils/dialog';
import { getFormatDate } from '@/utils/datetime';
export default {
  name: 'search-news',
  components: {
    SearchNewsDialog: defineAsyncComponent(() => import('@/components/information/SearchNewsDialog.vue')),
  },
  setup() {
    //取得條件
    const getSearchCondition = useGetters('news', ['getSearchCondition']);
    const getDateText = (arr) => {
      if (!arr || arr.length === 0) return '未設定';
      const d = getFormatDate();
      if (arr.every((e) => d === e)) return '當天';
      else return arr[0] + ' ~ ' + arr[1];
    };
    //彈窗
    const { dialogTemplate, openDialog } = useDialog();
    return { getSearchCondition, dialogTemplate, openDialog, getDateText };
  },
};
</script>
<style lang="scss" scoped>
.search-condition-wrap {
  @include white-bg;
  display: flex;
  align-items: center;
  padding: 16px 22px 0;
  position: relative;
  .button-wrap {
    position: absolute;
    top: 16px;
    right: 22px;
  }
}
</style>
